import styled from 'styled-components';
import ReceiptLayout from '@/components/Receipt/ReceiptLayout';
import { useLocation } from 'react-router';
import { FRANCHISEE_AIRPORT_ITEM } from '@repo/types';
import { IGlobalState } from '@/store';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { useQuery } from 'react-query';
import { getReceipt } from '@/api';
import ReceiptItem from '@/components/Airport/ReceiptItem';
import { useState } from 'react';
import DetailBillModal from '@/components/Airport/DetailBillModal';

const AirportReceipt = () => {
  const location = useLocation<{ displays: FRANCHISEE_AIRPORT_ITEM[] }>();
  const items = location.state ? location.state.displays : [];
  const [openedBillIndex, setOpenedBillIndex] = useState(-1);

  const { passportNumber, nationality, refundAfter } = useAppSelector(
    (state) => state,
  ) as IGlobalState;

  const { data } = useQuery(
    ['storeReceiptDetailList'],
    () =>
      getReceipt({
        passportNumber,
        refundAfter,
        latest: true,
      }),
    { enabled: !!passportNumber },
  );

  return (
    <>
      <ReceiptLayout hasPadding={false}>
        <Title>
          {nationality === 'KOR' ? '나의 택스리펀 영수증' : 'My Receipts'}
        </Title>
        {data && (
          <RefundItemList>
            {data.map((item, index) => {
              const defaultInfo = items.find(
                (i) => i.refundIndex === item.refundIndex,
              );
              const info = {
                franchiseeName: item.franchiseeName,
                refundIndex: item.refundIndex,
                category: item.category || '',
                saleDate: item.saleDate || '',
                price: Number(item.totalAmount) || 0,
                refund: Number(item.totalRefund) || 0,
                purchaseSn: defaultInfo?.purchaseSn || '',
              };

              return (
                <ReceiptItem
                  key={index}
                  {...info}
                  onOpenPreview={() => setOpenedBillIndex(index)}
                />
              );
            })}
          </RefundItemList>
        )}
      </ReceiptLayout>
      {openedBillIndex > -1 && items && (
        <DetailBillModal
          billList={items}
          openedId={openedBillIndex}
          onClose={() => setOpenedBillIndex(-1)}
        />
      )}
    </>
  );
};

const Title = styled.h2`
  width: 100%;
  padding: 12px 20px 20px 20px;
  color: #3a3b3e;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  box-shadow: 0px 4px 4px 0px rgba(216, 216, 216, 0.25);
  background-color: #fff;
  z-index: 1;
`;

const RefundItemList = styled.div`
  width: 100%;
  align-items: center;
  flex-direction: 'column-reverse';
  padding: 20px;
`;

export default AirportReceipt;
